import { createContext, useContext, useState, type ReactNode } from "react";

interface PrivacyContextValue {
  isPrivate: boolean;
  toggle: () => void;
}

const PrivacyContext = createContext<PrivacyContextValue>({
  isPrivate: false,
  toggle: () => {},
});

export function usePrivacy(): PrivacyContextValue {
  return useContext(PrivacyContext);
}

export function PrivacyProvider({ children }: { children: ReactNode }) {
  const [isPrivate, setIsPrivate] = useState<boolean>(() => {
    try {
      return localStorage.getItem("pazuru-privacy") === "true";
    } catch {
      return false;
    }
  });

  const toggle = () => {
    setIsPrivate((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("pazuru-privacy", String(next));
      } catch {
        // storage unavailable
      }
      return next;
    });
  };

  return (
    <PrivacyContext.Provider value={{ isPrivate, toggle }}>
      {children}
    </PrivacyContext.Provider>
  );
}
